<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
            <el-breadcrumb-item>品牌管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" type="card" @tab-click="changeActive">
            <el-tab-pane name="first">
                <span slot="label">品牌管理</span>
            </el-tab-pane>
            <el-tab-pane name="second">
                <span slot="label">待审核</span>
            </el-tab-pane>
        </el-tabs>
        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="品牌名称">
                <el-input v-model="item.name" placeholder="请输入商品名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="所属供应商">
                <el-select v-model="item.supplier_id" filterable clearable placeholder="请所属供应商" size="small">
                    <el-option
                            v-for="item in options_supplier"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['admin/brand/add']">添加品牌</el-button>
            <el-button type="danger" size="small" @click="delAll" v-auth="['admin/brand/delete']">批量删除</el-button>
        </div>
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="name" label="品牌名称"></el-table-column>
            <el-table-column label="所属供应商">
                <template slot-scope="scope">
                    {{scope.row.supplier ? scope.row.supplier.name : ''}}
                </template>
            </el-table-column>
            <el-table-column label="品牌图标">

            </el-table-column>
            <el-table-column prop="orders" label="排序"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/brand/update']">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['admin/brand/delete']">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list:[],
                isLoad:false,
                pageSize:20,
                total:0,
                item: {

                },
                options_supplier: [],
                page:1,
                multipleSelection:[],
                activeName: 'first'
            }
        },
        created() {
            this.loadList()
            this.getData()
        },
        methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url,
					query: {
						page: this.item.page
					}
				});
				window.open(link.href, '_blank')
			},
            getData() {
                this.axios.post('/admin/supplier/list', {
                    pagesize: 0
                }).then(res => {
                    this.options_supplier = res.data.list;
                })
            },
            // 搜索查询
            submit() {
                this.page = 1
                this.loadList()
            },
            loadList(){
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/brand/listByPage',Object.assign({
                    page: this.page,
                    limit: this.pageSize
                }, this.item)).then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.list.data
                        // 页数 page
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            changeActive: function (tab, event) {
                if (this.activeName == 'second') {
                    this.$router.push({
                        path: '/Basics/brandApply.html',
                    });
                }
            },
            // navigatorTo: function (url) {
            //     console.log(url)
            //     this.$router.push({
            //         path: url,
            //         query:{
            //         }
            //     });
            // },
            // 跳转到edit添加
            add(){
                this.$router.push({path: '/Basics/brandEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id){
                this.$router.push({
                    path:'/Basics/brandEdit.html',
                    query:{
                        id:id
                    }
                });
            },
            //
            del(id){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/brand/delete', {
                    data: {
                        ids: id
                    }
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose:false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll(){
                let id = []
                for(let key in this.multipleSelection){
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/brand/delete', {
                    data: {
                        ids: id
                    }
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose:false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            sizeReload(val){
                this.pageSize = val
                this.loadList()
            },
            pageReload(val){
                this.page = val
                this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
